<template>
    <span>
        <div v-html="svg"></div>
    </span>
</template>

<script>
// Remplacement Vite de `laravel-mix-vue-svgicon/IconComponent`.
// Sous laravel-mix, le composant faisait `require(`SVGPATH/${icon}.svg`)`
// (html-loader -> chaîne SVG). On charge ici tous les SVG en chaînes brutes
// via import.meta.glob (?raw) et on les indexe par nom de fichier.
const modules = import.meta.glob('/public/resources/svg/vue/*.svg', {
    query: '?raw',
    import: 'default',
    eager: true,
})

const icons = {}
for (const filePath in modules) {
    const name = filePath.split('/').pop().replace(/\.svg$/, '')
    icons[name] = modules[filePath]
}

export default {
    name: 'IconComponent',
    props: {
        icon: {
            type: String,
        },
    },
    computed: {
        svg() {
            return icons[this.icon] || ''
        },
    },
}
</script>
